var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mensagem)?_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({attrs:{"color":_vm.color,"dark":""}},on),[_vm._v("info")])]}}],null,false,2590703436)},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.mensagem)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }